module.exports = __webpack_public_path__ + "static/john-mark-arnold-xbBaOa_dd5I-unsplash-8bd73d08fee1a91aaccd5b6d81877812.png";